// Generated by ReScript, PLEASE EDIT WITH CARE


var value = {
    "vehicles": {
        "on_demand": [
            {
                "id": 3,
                "display_name": "2 Wheeler",
                "details": [
                    {
                        "key": "Capacity",
                        "value": "20 kg"
                    },
                    {
                        "key": "Size",
                        "value": "1.47 ft x 1.47ft x 1.47ft"
                    }
                ],
                "icons": {
                    "map_marker": "",
                    "selected": "",
                    "deselected": "",
                    "map_marker_top_view": null,
                    "v2": {
                        "selected": "",
                        "deselected": "",
                        "enlarged": "",
                        "disabled": ""
                    }
                },
                "allowed_goods_type_names": [
                    {
                        "id": 13,
                        "name": "Timber / Plywood / Laminate"
                    },
                    {
                        "id": 11,
                        "name": "Electrical / Electronics / Home Appliances"
                    },
                    {
                        "id": 1,
                        "name": "Perishable food items"
                    },
                    {
                        "id": 4,
                        "name": "Pharmacy / Medical / Healthcare / Fitness Equipment"
                    },
                    {
                        "id": 5,
                        "name": "FMCG / Food Products"
                    },
                    {
                        "id": 7,
                        "name": "Building / Construction"
                    },
                    {
                        "id": 8,
                        "name": "Catering / Restaurant / Event Management"
                    },
                    {
                        "id": 9,
                        "name": "Chemicals / Paints"
                    },
                    {
                        "id": 10,
                        "name": "Machines / Equipments / Spare Parts / Metals"
                    },
                    {
                        "id": 12,
                        "name": "Textile / Garments / Fashion Accessories"
                    },
                    {
                        "id": 14,
                        "name": "Furniture / Home Furnishing"
                    },
                    {
                        "id": 15,
                        "name": "House Shifting"
                    },
                    {
                        "id": 16,
                        "name": "Ceramics / Sanitary / Hardware"
                    },
                    {
                        "id": 17,
                        "name": "Paper / Packaging / Printed Material"
                    },
                    {
                        "id": 18,
                        "name": "Logistics service provider / Packers and Movers"
                    },
                    {
                        "id": 19,
                        "name": "Plastic / Rubber"
                    },
                    {
                        "id": 20,
                        "name": "Books / Stationery / Toys / Gifts"
                    }
                ],
                "value_added_services": [
                    {
                        "vas_type": "labour",
                        "off_messages": [
                            "Fare doesn't include labour charges for loading \u0026 unloading"
                        ],
                        "services": [
                            {
                                "is_enabled": false,
                                "service_type": "helper"
                            },
                            {
                                "is_enabled": false,
                                "service_type": "helper_plus_labour"
                            }
                        ]
                    }
                ]
            },
            {
                "id": 1,
                "display_name": "Pickup",
                "details": [
                    {
                        "key": "Capacity",
                        "value": "1050 kg"
                    },
                    {
                        "key": "Size",
                        "value": "7.6ft x 5.4ft x 4.2ft"
                    }
                ],
                "icons": {
                    "map_marker": "",
                    "selected": "",
                    "deselected": "",
                    "map_marker_top_view": null,
                    "v2": {
                        "selected": "",
                        "deselected": "",
                        "enlarged": "",
                        "disabled": ""
                    }
                },
                "allowed_goods_type_names": [
                    {
                        "id": 13,
                        "name": "Timber / Plywood / Laminate"
                    },
                    {
                        "id": 11,
                        "name": "Electrical / Electronics / Home Appliances"
                    },
                    {
                        "id": 1,
                        "name": "Perishable food items"
                    },
                    {
                        "id": 4,
                        "name": "Pharmacy / Medical / Healthcare / Fitness Equipment"
                    },
                    {
                        "id": 5,
                        "name": "FMCG / Food Products"
                    },
                    {
                        "id": 7,
                        "name": "Building / Construction"
                    },
                    {
                        "id": 8,
                        "name": "Catering / Restaurant / Event Management"
                    },
                    {
                        "id": 9,
                        "name": "Chemicals / Paints"
                    },
                    {
                        "id": 10,
                        "name": "Machines / Equipments / Spare Parts / Metals"
                    },
                    {
                        "id": 12,
                        "name": "Textile / Garments / Fashion Accessories"
                    },
                    {
                        "id": 14,
                        "name": "Furniture / Home Furnishing"
                    },
                    {
                        "id": 15,
                        "name": "House Shifting"
                    },
                    {
                        "id": 16,
                        "name": "Ceramics / Sanitary / Hardware"
                    },
                    {
                        "id": 17,
                        "name": "Paper / Packaging / Printed Material"
                    },
                    {
                        "id": 18,
                        "name": "Logistics service provider / Packers and Movers"
                    },
                    {
                        "id": 19,
                        "name": "Plastic / Rubber"
                    },
                    {
                        "id": 20,
                        "name": "Books / Stationery / Toys / Gifts"
                    }
                ],
                "value_added_services": [
                    {
                        "vas_type": "labour",
                        "off_messages": [
                            "Fare doesn't include labour charges for loading \u0026 unloading"
                        ],
                        "services": [
                            {
                                "is_enabled": false,
                                "service_type": "helper"
                            },
                            {
                                "is_enabled": false,
                                "service_type": "helper_plus_labour"
                            }
                        ]
                    }
                ]
            },
            {
                "id": 2,
                "display_name": "Canter 3 Ton",
                "details": [
                    {
                        "key": "Capacity",
                        "value": "3510 kg"
                    },
                    {
                        "key": "Size",
                        "value": "15.2 ft x 5.5ft x 6.5ft"
                    }
                ],
                "icons": {
                    "map_marker": "",
                    "selected": "",
                    "deselected": "",
                    "map_marker_top_view": null,
                    "v2": {
                        "selected": "",
                        "deselected": "",
                        "enlarged": "",
                        "disabled": ""
                    }
                },
                "allowed_goods_type_names": [
                    {
                        "id": 13,
                        "name": "Timber / Plywood / Laminate"
                    },
                    {
                        "id": 11,
                        "name": "Electrical / Electronics / Home Appliances"
                    },
                    {
                        "id": 1,
                        "name": "Perishable food items"
                    },
                    {
                        "id": 4,
                        "name": "Pharmacy / Medical / Healthcare / Fitness Equipment"
                    },
                    {
                        "id": 5,
                        "name": "FMCG / Food Products"
                    },
                    {
                        "id": 7,
                        "name": "Building / Construction"
                    },
                    {
                        "id": 8,
                        "name": "Catering / Restaurant / Event Management"
                    },
                    {
                        "id": 9,
                        "name": "Chemicals / Paints"
                    },
                    {
                        "id": 10,
                        "name": "Machines / Equipments / Spare Parts / Metals"
                    },
                    {
                        "id": 12,
                        "name": "Textile / Garments / Fashion Accessories"
                    },
                    {
                        "id": 14,
                        "name": "Furniture / Home Furnishing"
                    },
                    {
                        "id": 15,
                        "name": "House Shifting"
                    },
                    {
                        "id": 16,
                        "name": "Ceramics / Sanitary / Hardware"
                    },
                    {
                        "id": 17,
                        "name": "Paper / Packaging / Printed Material"
                    },
                    {
                        "id": 18,
                        "name": "Logistics service provider / Packers and Movers"
                    },
                    {
                        "id": 19,
                        "name": "Plastic / Rubber"
                    },
                    {
                        "id": 20,
                        "name": "Books / Stationery / Toys / Gifts"
                    }
                ],
                "value_added_services": [
                    {
                        "vas_type": "labour",
                        "off_messages": [
                            "Fare doesn't include labour charges for loading \u0026 unloading"
                        ],
                        "services": [
                            {
                                "is_enabled": false,
                                "service_type": "helper"
                            },
                            {
                                "is_enabled": false,
                                "service_type": "helper_plus_labour"
                            }
                        ]
                    }
                ]
            },
             {
                "id": 4,
                "display_name": "Canter 3 Ton",
                "details": [
                    {
                        "key": "Capacity",
                        "value": "3510 kg"
                    },
                    {
                        "key": "Size",
                        "value": "15.2 ft x 5.5ft x 6.5ft"
                    }
                ],
                "icons": {
                    "map_marker": "",
                    "selected": "",
                    "deselected": "",
                    "map_marker_top_view": null,
                    "v2": {
                        "selected": "",
                        "deselected": "",
                        "enlarged": "",
                        "disabled": ""
                    }
                },
                "allowed_goods_type_names": [
                    {
                        "id": 13,
                        "name": "Timber / Plywood / Laminate"
                    },
                    {
                        "id": 11,
                        "name": "Electrical / Electronics / Home Appliances"
                    },
                    {
                        "id": 1,
                        "name": "Perishable food items"
                    },
                    {
                        "id": 4,
                        "name": "Pharmacy / Medical / Healthcare / Fitness Equipment"
                    },
                    {
                        "id": 5,
                        "name": "FMCG / Food Products"
                    },
                    {
                        "id": 7,
                        "name": "Building / Construction"
                    },
                    {
                        "id": 8,
                        "name": "Catering / Restaurant / Event Management"
                    },
                    {
                        "id": 9,
                        "name": "Chemicals / Paints"
                    },
                    {
                        "id": 10,
                        "name": "Machines / Equipments / Spare Parts / Metals"
                    },
                    {
                        "id": 12,
                        "name": "Textile / Garments / Fashion Accessories"
                    },
                    {
                        "id": 14,
                        "name": "Furniture / Home Furnishing"
                    },
                    {
                        "id": 15,
                        "name": "House Shifting"
                    },
                    {
                        "id": 16,
                        "name": "Ceramics / Sanitary / Hardware"
                    },
                    {
                        "id": 17,
                        "name": "Paper / Packaging / Printed Material"
                    },
                    {
                        "id": 18,
                        "name": "Logistics service provider / Packers and Movers"
                    },
                    {
                        "id": 19,
                        "name": "Plastic / Rubber"
                    },
                    {
                        "id": 20,
                        "name": "Books / Stationery / Toys / Gifts"
                    }
                ],
                "value_added_services": [
                    {
                        "vas_type": "labour",
                        "off_messages": [
                            "Fare doesn't include labour charges for loading \u0026 unloading"
                        ],
                        "services": [
                            {
                                "is_enabled": false,
                                "service_type": "helper"
                            },
                            {
                                "is_enabled": false,
                                "service_type": "helper_plus_labour"
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export {
  value ,
  
}
/* No side effect */
